import Header from "../components/Header";
import Footer from "../components/Footer";

export default function BusinessAdvisory() {
  return (
    <>
      <Header />

      {/* ===== HERO SECTION ===== */}

      <section
        className="about-hero"
        style={{
          backgroundImage: "url('/assets/img/BusinessAdvisory.jpeg')",
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>Business Advisory </h1>
          <p>Strategic Insight. Financial Discipline. Sustainable Growth.</p>
        </div>
      </section>

      {/* ===== INTRO SECTION ===== */}
      <section className="ba-intro container my-5">
        <h2>Empowering Businesses with Expert Financial Leadership</h2>
        <p className="service-text">
          In today’s dynamic business environment, organizations need more than
          accounting — they need strategic financial leadership. At{" "}
          <strong>S D P M & Co.</strong>, our Business Advisory & Virtual CFO
          Services help enhance profitability, streamline operations, and
          provide actionable financial insights.
        </p>
      </section>

      {/* ===== CONTENT SECTION ===== */}
      <section className="ba-content container my-4">
        <div className="row gy-4">
          {/* Card 1 */}
          <div className="col-md-6">
            <div className="ba-card">
              <h4>📊 Financial Planning & MIS Reporting</h4>
              <p>
                We create structured reporting systems that drive smarter
                decisions through data-backed insights.
              </p>
              <ul>
                <li>Monthly & quarterly MIS reports</li>
                <li>Profitability & cash flow analysis</li>
                <li>Working capital management</li>
                <li>KPI dashboards & performance reviews</li>
              </ul>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-6">
            <div className="ba-card">
              <h4>🧮 Budgeting, Forecasting & Cost Controls</h4>
              <p>
                Build a robust financial roadmap ensuring efficient use of
                resources and better profitability.
              </p>
              <ul>
                <li>Annual budgets & rolling forecasts</li>
                <li>Variance & cost optimization analysis</li>
                <li>Break-even & margin improvement</li>
                <li>Department-wise budget control</li>
              </ul>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-md-6">
            <div className="ba-card">
              <h4>💼 Business Valuations & Due Diligence</h4>
              <p>
                Accurate and compliant valuations for mergers, fundraising, or
                restructuring.
              </p>
              <ul>
                <li>Business valuation (DCF, NAV, Market multiples)</li>
                <li>Startup & share valuations for funding/ESOPs</li>
                <li>Financial & tax due diligence</li>
                <li>Regulatory-compliant reports</li>
              </ul>
            </div>
          </div>

          {/* Card 4 */}
          <div className="col-md-6">
            <div className="ba-card">
              <h4>🛡️ Internal Controls & SOP Development</h4>
              <p>
                Design and implement effective SOPs to ensure transparency and
                operational control.
              </p>
              <ul>
                <li>Process mapping & risk identification</li>
                <li>Internal control system (ICFR/IFC)</li>
                <li>Documentation of SOPs</li>
                <li>Fraud risk assessment</li>
              </ul>
            </div>
          </div>

          {/* Card 5 */}
          <div className="col-md-6">
            <div className="ba-card">
              <h4>🔄 Business Restructuring & Exit Planning</h4>
              <p>
                Helping businesses realign and optimize their structures for
                better outcomes.
              </p>
              <ul>
                <li>Corporate restructuring & realignment</li>
                <li>Debt restructuring & lender negotiations</li>
                <li>Mergers, demergers, and buyouts</li>
                <li>Succession & exit strategy planning</li>
              </ul>
            </div>
          </div>

          {/* Card 6 */}
          <div className="col-md-6">
            <div className="ba-card">
              <h4>⚠️ Risk Management & Corporate Governance</h4>
              <p>
                Strengthening accountability and compliance through structured
                governance frameworks.
              </p>
              <ul>
                <li>Enterprise Risk Management (ERM)</li>
                <li>Governance structure & policy drafting</li>
                <li>Compliance framework review</li>
                <li>Integrity & transparency initiatives</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* <div className="nri-highlight my-5">
        <h3> Why Choose Our Business Advisory Services?</h3>
        <ul>
          <li> Team of Chartered Accountants experts</li>
          <li> Tailored financial strategies for every business size</li>
          <li> End-to-end support — from planning to monitoring</li>
          <li> Technology-driven financial insights</li>
          <li> Proven results in profitability and governance</li>
        </ul>
      </div> */}

      {/* ===== CTA SECTION ===== */}
      {/* <section className="ba-cta text-center my-5">
        <div className="container">
          <h3> Transform Your Business With Expert Financial Leadership</h3>
          <p>
            Let <strong>S D P M & Co.</strong> help your business achieve
            financial excellence with clarity, control, and confidence.
          </p>

          <Link
            to="/contactus"
            className="btn px-4 py-2 fw-semibold"
            style={{
              backgroundColor: "#65ad4b",
              color: "#fff",
              borderRadius: "8px",
            }}
            onClick={() => window.scrollTo({ top: 0 })}
          >
            Contact Us
          </Link>
        </div>
      </section> */}

      <Footer />
    </>
  );
}
